import DOMPurify from 'dompurify';
import { useMemo, type ReactElement } from 'react';

/**
 * Renders company-authored HTML that arrives from the database. The markup is
 * outside our control, so it is sanitised before injection — a stored <script>
 * or an onerror attribute in a job description would otherwise execute with the
 * app's origin and session.
 */
export function RichText({ html, className }: { html: string; className?: string }): ReactElement {
  const clean = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        ADD_ATTR: ['target', 'rel'],
        FORBID_TAGS: ['style', 'script', 'iframe', 'form', 'input'],
        FORBID_ATTR: ['style', 'srcset'],
      }),
    [html],
  );

  return (
    <div
      className={`rich-text ${className ?? ''}`}
      // Sanitised immediately above; DOMPurify strips scripts and event handlers.
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
